import React, { useState, useEffect } from "react";
import { FaCheck, FaCrown, FaGem, FaStar } from "react-icons/fa";
import { buySubscription, fetchActiveInfluencerSubscriptions, fetchMyeSubscriptions } from "../../services/Common.ts";
import { useTheme } from "../../contexts/ThemeContext.tsx";
import { themes } from '../../theme.ts';

declare global {
  interface Window {
    Razorpay: any;
  }
}

interface Plan {
  id: number;
  title: string;
  offer_price: number;
  duration: string;
  key_points: string[];
  active: boolean;
}

interface MyPlan {
  subscription: number;
  end_date: string;
}

const InfluencerSubscriptions: React.FC = () => {
  const { themeName } = useTheme();
  const [loading, setLoading] = useState(false);
  const [plans, setPlans] = useState<Plan[]>([]);
  const [myplans, setMyPlans] = useState<MyPlan[]>([]);
  const [selectedPlan, setSelectedPlan] = useState<Plan | null>(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [razorpayLoaded, setRazorpayLoaded] = useState(false);

  const rawData = localStorage.getItem("user");
  const cred = rawData ? JSON.parse(rawData) : null;
  const token = cred?.access;
  const [currentPlanInfo, setCurrentPlanInfo] = useState<Plan | null>(null);

  // Load Razorpay script dynamically
  useEffect(() => {
    const loadRazorpay = () => {
      return new Promise((resolve, reject) => {
        if (window.Razorpay) {
          setRazorpayLoaded(true);
          resolve(true);
          return;
        }

        const script = document.createElement('script');
        script.src = 'https://checkout.razorpay.com/v1/checkout.js';
        script.onload = () => {
          setRazorpayLoaded(true);
          resolve(true);
        };
        script.onerror = () => {
          reject(new Error('Failed to load Razorpay'));
        };
        document.body.appendChild(script);
      });
    };

    loadRazorpay().catch(console.error);
  }, []);

  const fetchplans = async () => {
    setLoading(true);
    try {
      const response: any = await fetchActiveInfluencerSubscriptions(token);
      setPlans(response?.data || []);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const fetchMyplans = async () => {
    setLoading(true);
    try {
      const response: any = await fetchMyeSubscriptions(token);
      setMyPlans(response?.data?.subscriptions || []);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchplans();
    fetchMyplans();
  }, []);


  const handleUpgradeClick = (plan: Plan) => {
    setSelectedPlan(plan);
    setIsPopupOpen(true);
  };


  // const handlePayment = async () => {
  //   try {
  //     // Check if Razorpay is loaded
  //     if (!window.Razorpay) {
  //       alert("Payment system is not loaded. Please refresh the page and try again.");
  //       return;
  //     }

  //     if (!selectedPlan) return;

  //     const response = await buySubscription(token, String(selectedPlan.id));

  //     if (!(response as any).data) {
  //       throw new Error("No data received from server");
  //     }

  //     const { razorpay_order_id, amount, currency } = (response as any).data;

  //     if (!razorpay_order_id) {
  //       throw new Error("No order ID received from server");
  //     }

  //     if (!amount) {
  //       throw new Error("No amount received from server");
  //     }

  //     if (!razorpay_order_id.startsWith('order_')) {
  //       throw new Error(`Invalid order ID format: ${razorpay_order_id}`);
  //     }

  //     const options = {
  //       key: process.env.REACT_APP_RAZORPAY_KEY_ID,
  //       amount: amount.toString(),
  //       currency: currency || "INR",
  //       name: "SocialsCollab",
  //       description: `Upgrade to ${selectedPlan.title}`,
  //       order_id: razorpay_order_id,
  //       handler: function (paymentResponse: any) {
  //         console.log("Payment successful:", paymentResponse);
  //         alert("Payment successful! Your subscription has been upgraded.");
  //         setIsPopupOpen(false);
  //         fetchplans();
  //         fetchMyplans();
  //       },
  //       prefill: {
  //         name: cred?.name || "User",
  //         email: cred?.email || "user@example.com",
  //         contact: cred?.phone || "9999999999",
  //       },
  //       theme: {
  //         color: "#1cbfbf",
  //       },
  //       modal: {
  //         ondismiss: function () {
  //           console.log("Payment modal closed by user");
  //           setIsPopupOpen(false);
  //         }
  //       }
  //     };

  //     const razorpay = new window.Razorpay(options);

  //     razorpay.on('payment.failed', function (response: any) {
  //       console.error('Payment failed:', response.error);
  //       alert(`Payment failed: ${response.error.description}`);
  //       setIsPopupOpen(false);
  //     });

  //     razorpay.open();

  //   } catch (err: any) {
  //     console.error("Payment initialization failed:", err);

  //     if (err.message && (err.message.includes("order ID") || err.message.includes("Invalid order ID"))) {
  //       alert("Server error: Invalid order received. Please contact support.");
  //     } else if (err.response) {
  //       console.error("Server error response:", err.response.data);
  //       alert(`Server error: ${err.response.data.message || 'Please try again later'}`);
  //     } else {
  //       alert(`Error: ${err.message}`);
  //     }

  //     setIsPopupOpen(false);
  //   }
  // };

  useEffect(() => {
    if (plans?.length && myplans?.length) {
      const myplan = myplans[0]
      const info = plans.find((plan) => plan.id === myplan.subscription);
      if (info) {
        setCurrentPlanInfo(info);
      }
    }
  }, [plans, myplans]);


  return (
    <div className="h-screen flex flex-col overflow-hidden">
      {/* Header */}
      <div
        className="p-4 flex-shrink-0"
        style={{
          background: `linear-gradient(to right, ${themes[themeName].colors.primary}, ${themes[themeName].colors.secondary})`
        }}
      >
        <div className="">
          <h2
            className="text-xl font-bold mb-4"
            style={{ color: '#FFFFFF' }}
          >
            Subscription Plans
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <div
              className="backdrop-blur-sm rounded-lg p-3"
              style={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                color: '#FFFFFF'
              }}
            >
              <div className="flex items-center gap-2 mb-1">
                <FaCrown size={18} />
                <h3 className="text-base font-semibold">Current Plan</h3>
              </div>
              <p className="text-2xl font-bold">{currentPlanInfo?.title || "NO PLAN"}</p>
            </div>
            <div
              className="backdrop-blur-sm rounded-lg p-3"
              style={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                color: '#FFFFFF'
              }}
            >
              <div className="flex items-center gap-2 mb-1">
                <FaCheck size={18} />
                <h3 className="text-base font-semibold">Renewal Date</h3>
              </div>
              <p className="text-2xl font-bold">{myplans[0]?.end_date || "NA"}</p>
            </div>
            <div
              className="backdrop-blur-sm rounded-lg p-3"
              style={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                color: '#FFFFFF'
              }}
            >
              <div className="flex items-center gap-2 mb-1">
                <FaStar size={18} />
                <h3 className="text-base font-semibold">Status</h3>
              </div>
              <p className="text-2xl font-bold">{currentPlanInfo?.active ? "Active" : "InActive"}</p>
            </div>
            <div
              className="backdrop-blur-sm rounded-lg p-3"
              style={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                color: '#FFFFFF'
              }}
            >
              <div className="flex items-center gap-2 mb-1">
                <FaGem size={18} />
                <h3 className="text-base font-semibold">Next Billing</h3>
              </div>
              <p className="text-2xl font-bold">Rs {currentPlanInfo?.offer_price || "NA"}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      {loading ? (
        <div className="flex justify-center items-center mt-6">
          <div
            className="border-t-4 rounded-full w-12 h-12 animate-spin"
            style={{ borderColor: themes[themeName].colors.primary }}
          ></div>
          <p
            className="ml-4"
            style={{ color: themes[themeName].colors.primary }}
          >
            Loading...
          </p>
        </div>
      ) : (
        <div
          className="flex-1 overflow-y-auto p-4"
          style={{ backgroundColor: themes[themeName].colors.background }}
        >
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {plans?.map((plan) => {
              const myplan = myplans.find((p) => p.subscription === plan?.id);
              return (
                <div
                  key={plan.id}
                  className="relative rounded-xl shadow-lg p-4"
                  style={{
                    backgroundColor: themes[themeName].colors.surface,
                    borderColor: myplan ? themes[themeName].colors.primary : themes[themeName].colors.border,
                    borderWidth: 2,
                    borderStyle: 'solid'
                  }}
                >
                  {myplan && (
                    <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                      <span
                        className="px-3 py-1 rounded-full text-xs font-semibold"
                        style={{
                          backgroundColor: themes[themeName].colors.primary,
                          color: '#FFFFFF'
                        }}
                      >
                        Current Plan
                      </span>
                    </div>
                  )}
                  <div className="flex flex-col items-center justify-between mb-3">
                    <div className="flex items-center justify-center w-[100%] gap-2">
                      <FaStar
                        style={{
                          color: myplan ? themes[themeName].colors.primary : themes[themeName].colors.warning
                        }}
                      />
                      <h3
                        className="text-lg font-bold"
                        style={{ color: themes[themeName].colors.text }}
                      >
                        {plan?.title}
                      </h3>
                    </div>
                    <div
                      className="flex justify-center items-center text-lg w-full font-bold"
                      style={{ color: themes[themeName].colors.primary }}
                    >
                      Rs {plan?.offer_price}
                      <span
                        className="text-xs lowercase ml-1"
                        style={{ color: themes[themeName].colors.textSecondary }}
                      >
                        /{plan?.duration}
                      </span>
                    </div>

                  </div>
                  <ul className="space-y-2 mb-4">
                    {plan?.key_points.map((feature, index) => (
                      <li
                        key={index}
                        className="flex items-center gap-2 text-sm"
                        style={{ color: themes[themeName].colors.textSecondary }}
                      >
                        <FaCheck color={themes[themeName].colors.success} size={14} />
                        {feature}
                      </li>
                    ))}
                  </ul>
                  <button
                    className="w-full py-2 rounded-lg text-sm font-semibold"
                    style={{
                      backgroundColor: myplan ? themes[themeName].colors.textMuted : themes[themeName].colors.primary,
                      color: myplan ? themes[themeName].colors.text : '#FFFFFF',
                      opacity: myplan ? 0.6 : 1
                    }}
                    disabled={!!myplan}
                    onClick={() => handleUpgradeClick(plan)}
                    onMouseEnter={(e) => {
                      if (!myplan) {
                        e.currentTarget.style.opacity = '0.9';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!myplan) {
                        e.currentTarget.style.opacity = '1';
                      }
                    }}
                  >
                    {myplan ? "Current Plan" : "Upgrade Now"}
                  </button>
                </div>
              )
            }
            )}
          </div>
        </div>
      )}

      {/* Payment Confirmation Popup */}
      {isPopupOpen && selectedPlan && (
        <div
          className="fixed inset-0 flex items-center justify-center z-[101] px-4"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)' }}
        >
          <div
            className="w-[90%] md:w-[50%] p-6 rounded-lg shadow-lg"
            style={{
              backgroundColor: themes[themeName].colors.surface,
              borderColor: themes[themeName].colors.border,
              borderWidth: 1,
              borderStyle: 'solid'
            }}
          >
            <h2
              className="text-xl font-bold mb-4"
              style={{ color: themes[themeName].colors.text }}
            >
              Confirm Payment
            </h2>
            <p
              className="mb-4"
              style={{ color: themes[themeName].colors.textSecondary }}
            >
              You are about to upgrade to the{" "}
              <span
                className="font-bold"
                style={{ color: themes[themeName].colors.primary }}
              >
                {selectedPlan.title}
              </span>{" "}
              plan for{" "}
              <span
                className="font-bold"
                style={{ color: themes[themeName].colors.primary }}
              >
                Rs {selectedPlan.offer_price}
              </span>
              .
            </p>
            <div className="flex justify-end space-x-4">
              <button
                onClick={() => setIsPopupOpen(false)}
                className="px-4 py-2 rounded-lg"
                style={{
                  backgroundColor: themes[themeName].colors.textMuted,
                  color: themes[themeName].colors.text
                }}
              >
                Cancel
              </button>
              {/* <button
                onClick={handlePayment}
                style={{
                  backgroundColor: themes[themeName].colors.primary,
                  color: '#FFFFFF'
                }}
                disabled={!razorpayLoaded}
                className="px-4 py-2 bg-[#1cbfbf] text-white rounded-lg disabled:opacity-50"
              >
                {razorpayLoaded ? "Pay with Razorpay" : "Loading Payment..."}
              </button> */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InfluencerSubscriptions;
